import React from "react";
import Navbar from "../Components/Navbar";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../CSS/theme.css";
import QuickLinks from "./QuickLinks";
import FooterNew from "../Components/FooterNew";

const Consultations = () => {
  const CWD = "";
  const heroBgImage = `${CWD}/assets/img/gallery/dr-banner-6.jpg`;
  return (
    <div style={{ maxWidth: "100%", overflow: "hidden" }}>
      <Navbar />
      <div className="Main-Header-Container">
        <section
          className="py-xxl-10 pb-0"
          id="home"
          style={{ background: "rgb(0 0 0 / 60%)", height: "610px" }}
        >
          <div
            className="bg-holder"
            style={{
              backgroundImage: `url(${heroBgImage})`,
              backgroundPosition: "bottom",
              backgroundSize: "cover",

              //   height: "100vh", // Add a height to ensure background is visible
            }}
          />

          <div className="container">
            <div className="row min-vh-xl-100 min-vh-xxl-25">
              <div className=" paddin-header   text-center ">
                <h2 className="">
                  <span
                    className=" general-tittle-mbl"
                    style={{
                      fontSize: "48px",
                      fontFamily: "Raleway, sanf-serif",
                      color: "#fff",
                      paddingBottom: " 10px",
                    }}
                  >
                    Consultations
                  </span>
                </h2>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div className="text-center py-6">
        {/* <h2>Initial consultation</h2> */}
      </div>
      <div
        className=" about-summary-inline"
        style={{
          padding: "5px 10px 0px",
          fontSize:"19px",
          marginBottom: "120px",
          textAlign:"justify"
        }}
      >
        <p>
          Consultations with Dr Ahmed are usually 20 minutes for a new patient
          and 15 minutes for follow ups.
          <br />
          <br />
          Procedures can take anywhere from 20 minutes to over an hour depending
          on complexity.
          <br />
          <br />
          Please note Dr Ahmed does not offer video consultations or review of
          patient photos.
        </p>
      </div>
      <div className="footer-import  footer-import-contact">
        <QuickLinks />
        <FooterNew />
      </div>
    </div>
  );
};

export default Consultations;
